<!--
 * @创建文件时间: 2019-10-29 15:53:34
 * @最后修改人: lfq
 * @最后修改时间: 2020-06-03 14:45:43
 * @联系Qq:1638245306
 * @文件介绍:
 -->
<template>
    <el-dialog class="dialogFormCom" :title="dialogTitle" :width="dialogWidth+'%'" :visible.sync="dialogVisible"
               @close="$emit('update:dialogFormVisible', false)" :open="onOpen" :append-to-body="true"
               :close-on-click-modal="false">
        <dynamic-form :ref='refName' :formConfig="formConfig" v-model="value" :disabled='disabled'>
             <template slot="yjj_zy">
                <slot name="yjj_zy"></slot>
              </template>
        </dynamic-form>
        <div v-if="isImgVideo.showImgVideo">
            <divider :title="isImgVideo.isVideo?(isImgVideo.titel+'图片/视频'):(isImgVideo.titel+'图片')"/>
            <el-card class="box-card card_margintop">
                <div class="text-align_right">
                    <dialogImg :dialogShow="dialogShows" :actionType="isImgVideo.actionType"
                               @successData="successData"></dialogImg>
                    <el-button type="success" v-if="!disabled" size="small" @click="dialogShows=true">上传</el-button>
                </div>
                <imgVideo v-if="true" :data="imgVideoDatas" :delShow="(disabled?'3':delShow)" @delImg="delImg"
                          :isImg="isImgVideo.isImg" :isVideo="isImgVideo.isVideo"></imgVideo>
            </el-card>
        </div>
        <div v-if="isImgVideo.showImgVideo2">
            <divider :title="isImgVideo.isVideo?(isImgVideo.titel2+'图片/视频'):(isImgVideo.titel2+'图片')"/>
            <el-card class="box-card card_margintop">
                <div class="text-align_right">
                    <dialogImg :dialogShow="dialogShows2" :actionType="isImgVideo.actionType"
                               @successData="successData2"></dialogImg>
                    <el-button type="success" v-if="!disabled" size="small" @click="dialogShows2=true">上传
                    </el-button>
                </div>
                <imgVideo v-if="true" :data="imgVideoDatas2" :delShow="(disabled?'3':delShow)" @delImg="delImg2"
                          :isImg="isImgVideo.isImg" :isVideo="isImgVideo.isVideo"></imgVideo>
            </el-card>
        </div>
        <div v-if="isImgVideo.showImgVideo3">
            <divider :title="isImgVideo.isVideo?(isImgVideo.titel3+'图片/视频'):(isImgVideo.titel3+'图片')"/>
            <el-card class="box-card card_margintop">
                <div class="text-align_right">
                    <dialogImg :dialogShow="dialogShows3" :actionType="isImgVideo.actionType"
                               @successData="successData3"></dialogImg>
                    <el-button type="success" v-if="!disabled" size="small" @click="dialogShows3=true">上传
                    </el-button>
                </div>
                <imgVideo v-if="true" :data="imgVideoDatas3" :delShow="(disabled?'3':delShow)" @delImg="delImg3"
                          :isImg="isImgVideo.isImg" :isVideo="isImgVideo.isVideo"></imgVideo>
            </el-card>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="onCancel">取 消</el-button>
            <el-button type="primary" v-if="!disabled" size="small" @click="onSubmit">保 存</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'dialogForm',
    data() {
        return {
            refName: '',
            imgVideoDatas: "",
            imgVideoDatas2: "",
            imgVideoDatas3: "",
            dialogShows: false,
            dialogShows2: false,
            dialogShows3: false,
            dialogVisible: this.dialogFormVisible,
            forms: {}
        }
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        dialogWidth: {
            type: String,
            default: '60'
        },
        formConfig: {
            type: Object
        },
        value: {
            type: Object
        },
        dialogTitle: {
            type: String
        },
        dialogFormVisible: {
            type: Boolean,
            default: false
        },
        delShow: {
            default: '3',
        },
        imgVideoData: {
            type: String,
            default: ''
        },
        imgVideoData2: {
            type: String,
            default: ''
        },
        imgVideoData3: {
            type: String,
            default: ''
        },
        isImgVideo: {
            type: Object,
            default: () => {
                return {
                    actionType: "",
                    titel: "",
                    titel2: "",
                    titel3: "",
                    isImg: true,
                    isVideo: true,
                    showImgVideo: false,
                    showImgVideo2: false,
                    showImgVideo3: false,
                }
            }
        },
    },
    watch: {
        dialogFormVisible(val, oldVal) {
            if (val === oldVal) {
                return
            }
            this.dialogVisible = val
        },
        "imgVideoData": function (newVal) {
            this.imgVideoDatas = newVal;
        },
        "imgVideoData2": function (newVal) {
            this.imgVideoDatas2 = newVal;
        },
        "imgVideoData3": function (newVal) {
            this.imgVideoDatas3 = newVal;
        },
    },
    methods: {
        onCancel() {
            this.dialogVisible = false
            this.$emit('cancel')
        },
        onSubmit() {
            let that = this
            that.$refs[that.refName].submit().then(res => {
                this.$emit('onSubmit')
            })
        },
        resetForm(callback) {
            let form = this.$refs[this.refName]
            if (form && typeof form.resetForm === 'function'){
                return this.$refs[this.refName].resetForm(callback)
            }
        },
        onOpen() {

        },
        successData(val) {
            this.dialogShows = false;
            this.$emit('successData', val);
        },
        successData2(val) {
            this.dialogShows2 = false;
            this.$emit('successData2', val);
        },
        successData3(val) {
            this.dialogShows3 = false;
            this.$emit('successData3', val);
        },
        delImg(val) {
            this.$emit('delImg', val);
        },
        delImg2(val) {
            this.$emit('delImg2', val);
        },
        delImg3(val) {
            this.$emit('delImg3', val);
        },
    },
    created() {
        this.refName = 'dialogForm' + new Date().getTime()
    },
    updated() {
        if (this.$refs[this.refName]) {
            this.forms = this.$refs[this.refName].forms
            this.$emit('onLoadTag', this.$refs[this.refName].forms, this)
        }
    }
}
</script>

<style scoped>
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/aboutForm/dialogForm.vue"
}
</vue-filename-injector>
